// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-card[data-v-30607d5a] {\n  border: 1px solid #BED1DA;\n  border-radius: 10px;\n  width: 100%;\n}\n.service-card-header[data-v-30607d5a] {\n  position: relative;\n  background: #F4F4F8;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
